module.exports = "/out/13471c4f716c59008ca0ff0da7d6720a.png";